import type { ReviewPage } from './review-page';

export const googlePages: ReviewPage[] = [
  {
    label: 'California',
    children: [
      {
        label: 'Los Angeles, CA',
        href: 'https://www.google.com/maps/place/Marshall+Reddick+Real+Estate/@34.1454451,-118.136577,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2c3f0dc653893:0xaa743a307e10bf22!8m2!3d34.1454451!4d-118.136577!16s%2Fg%2F11k7p0xnjt',
      },
      {
        label: 'Orange County, CA',
        href: 'https://www.google.com/maps/place/Marshall+Reddick+Real+Estate/@33.665582,-117.8667747,17z/data=!4m12!1m6!3m5!1s0x80dcde584af85b11:0xacba1721e5488cda!2sMarshall+Reddick+Real+Estate!8m2!3d33.665582!4d-117.864586!3m4!1s0x80dcde584af85b11:0xacba1721e5488cda!8m2!3d33.665582!4d-117.864586',
      },
    ],
  },
  {
    label: 'Florida',
    children: [
      {
        label: 'Fort Myers, FL',
        href: 'https://www.google.com/maps/place/Marshall+Reddick+Real+Estate/@26.6633527,-81.9427554,17z/data=!4m12!1m6!3m5!1s0x88db46a5e52d67ad:0xc59bd1ac44473451!2sMarshall+Reddick+Real+Estate!8m2!3d26.6633479!4d-81.9405667!3m4!1s0x88db46a5e52d67ad:0xc59bd1ac44473451!8m2!3d26.6633479!4d-81.9405667',
      },
    ],
  },
  {
    label: 'Tennessee',
    children: [
      {
        label: 'Clarksville, TN',
        href: 'https://www.google.com/maps/place/Marshall+Reddick+Real+Estate/@36.5567407,-87.3240676,17z/data=!3m1!4b1!4m5!3m4!1s0x8864d98dc722e643:0xe41e31a6485492e2!8m2!3d36.5567364!4d-87.3218789',
      },
      {
        label: 'Nashville, TN',
        href: 'https://www.google.com/maps/place/Marshall+Reddick+Real+Estate/@36.1434967,-86.8172432,15z/data=!4m6!3m5!1s0x886467c75b8ec717:0x42e844ac2a04223b!8m2!3d36.1434967!4d-86.8172432!16s%2Fg%2F11l351555j',
      },
    ],
  },
  {
    label: 'Texas',
    children: [
      {
        label: 'Austin, TX',
        href: 'https://www.google.com/maps/place/Marshall+Reddick+Real+Estate/@30.3409607,-97.7045468,17z/data=!3m1!4b1!4m6!3m5!1s0x8644cb90c9702b79:0x165914dc10c1bae5!8m2!3d30.3409607!4d-97.7045468!16s%2Fg%2F11ncmtf3bp',
      },
      {
        label: 'Dallas, TX',
        href: 'https://maps.app.goo.gl/pKpbyTJstsLYMeQA7',
      },
      {
        label: 'Houston, TX',
        href: 'https://maps.app.goo.gl/cVQ33jHnU4KkCHMT8',
      },
      {
        label: 'New Braunfels, TX',
        href: 'https://www.google.com/maps/place/Marshall+Reddick+Real+Estate/@29.7034017,-98.1417626,17z/data=!3m1!4b1!4m5!3m4!1s0x865c97f57f8bb621:0x8413ed84008e8a25!8m2!3d29.7034017!4d-98.1395739',
      },
      {
        label: 'San Antonio, TX',
        href: 'https://www.google.com/maps/place/Marshall+Reddick+Real+Estate/@29.5537557,-98.5699513,1362m/data=!3m2!1e3!4b1!4m6!3m5!1s0x865c613ecea4d0cd:0x5747d8d73ca02e88!8m2!3d29.5537557!4d-98.5699513!16s%2Fg%2F11fk4dxwj2?entry=ttu&g_ep=EgoyMDI1MDQyOC4wIKXMDSoASAFQAw%3D%3D',
      },
    ],
  },
];
